import { render, staticRenderFns } from "./PrivacyAlarmEffect.vue?vue&type=template&id=6c32c46d&scoped=true"
import script from "./PrivacyAlarmEffect.vue?vue&type=script&lang=js"
export * from "./PrivacyAlarmEffect.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAlarmEffect.vue?vue&type=style&index=0&id=6c32c46d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32c46d",
  null
  
)

export default component.exports